import {
  ActivityStatus,
  type AssetComponentMetadata,
  AssetViewTracker,
  AttachmentsAsset,
  attachmentsAssetSettingsSchema,
  AudioAnswerAsset,
  audioAnswerAssetSettingsSchema,
  AudioAsset,
  audioAssetSettingsSchema,
  BlockQuoteAsset,
  blockQuoteAssetSettingsSchema,
  CategoryAsset,
  categoryAssetSettingsSchema,
  CollapsibleBoxAsset,
  collapsibleBoxAssetSettingsSchema,
  ConfirmationAsset,
  confirmationAssetSettingsSchema,
  ContentIntegrationAsset,
  contentIntegrationAssetSettingsSchema,
  DividerAsset,
  DividerAssetSettingsSchema,
  FileUploadAsset,
  fileUploadAssetSettingsSchema,
  type FileUploadHandlers,
  GalleryAsset,
  galleryAssetSettingsSchema,
  HotspotAnswerAsset,
  hotspotAnswerAssetSettingsSchema,
  HotspotAsset,
  hotspotAssetSettingsSchema,
  HotspotLabelAsset,
  hotspotLabelAssetSettingsSchema,
  ImageAsset,
  imageAssetSettingsSchema,
  InstructionAsset,
  instructionAssetSettingsSchema,
  MatchingListAsset,
  matchingListAssetSettingsSchema,
  MultipleChoiceAsset,
  multipleChoiceAssetSettingsSchema,
  MultistepAsset,
  multistepAssetSettingsSchema,
  normalizeWhitespace,
  type ResponseChangeProps,
  SectionHeaderAsset,
  sectionHeaderAssetSettingsSchema,
  SketchpadAsset,
  sketchpadAssetSettingsSchema,
  SortableListAsset,
  sortableListAssetSettingsSchema,
  SupplementalContentAsset,
  supplementalContentAssetSettingsSchema,
  TableAsset,
  TableAssetSettingsSchema,
  TextAnswerAsset,
  textAnswerAssetSettingsSchema,
  TextAsset,
  textAssetSettingsSchema,
  ThreeColumnAsset,
  threeColumnAssetSettingsSchema,
  TimelineAsset,
  timelineAssetSettingsSchema,
  TwoColumnAsset,
  twoColumnAssetSettingsSchema,
  VideoAnswerAsset,
  videoAnswerAssetSettingsSchema,
  VideoAsset,
  videoAssetSettingsSchema,
  YouPickAsset,
  youPickAssetSettingsSchema,
} from "@cca/components";
import {
  GradeAssetDto,
  GraderFeedbackDto,
} from "@cca/components/dist/components/assets/types";
import { AssetDto } from "@core/typesV2";
import { LcmsAssetType } from "@core/typesV2/lcms";
import { mapValues } from "remeda";
import { z } from "zod";

export const assetMap = new Map([
  [
    LcmsAssetType.Attachments,
    {
      element: AttachmentsAsset,
      settingsSchema: attachmentsAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.Audio,
    { element: AudioAsset, settingsSchema: audioAssetSettingsSchema },
  ],
  [
    LcmsAssetType.AudioAnswer,
    {
      element: AudioAnswerAsset,
      settingsSchema: audioAnswerAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.BlockQuote,
    {
      element: BlockQuoteAsset,
      settingsSchema: blockQuoteAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.Category,
    {
      element: CategoryAsset,
      settingsSchema: categoryAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.CollapsibleBox,
    {
      element: CollapsibleBoxAsset,
      settingsSchema: collapsibleBoxAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.Confirmation,
    {
      element: ConfirmationAsset,
      settingsSchema: confirmationAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.ContentIntegration,
    {
      element: ContentIntegrationAsset,
      settingsSchema: contentIntegrationAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.Divider,
    {
      element: DividerAsset,
      settingsSchema: DividerAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.FileUpload,
    {
      element: FileUploadAsset,
      settingsSchema: fileUploadAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.Gallery,
    {
      element: GalleryAsset,
      settingsSchema: galleryAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.HotspotAnswer,
    {
      element: HotspotAnswerAsset,
      settingsSchema: hotspotAnswerAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.Hotspot,
    {
      element: HotspotAsset,
      settingsSchema: hotspotAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.HotspotLabel,
    {
      element: HotspotLabelAsset,
      settingsSchema: hotspotLabelAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.Image,
    { element: ImageAsset, settingsSchema: imageAssetSettingsSchema },
  ],
  [
    LcmsAssetType.Instruction,
    {
      element: InstructionAsset,
      settingsSchema: instructionAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.MatchingList,
    {
      element: MatchingListAsset,
      settingsSchema: matchingListAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.MultipleChoice,
    {
      element: MultipleChoiceAsset,
      settingsSchema: multipleChoiceAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.Multistep,
    {
      element: MultistepAsset,
      settingsSchema: multistepAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.SectionHeader,
    {
      element: SectionHeaderAsset,
      settingsSchema: sectionHeaderAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.Sketchpad,
    {
      element: SketchpadAsset,
      settingsSchema: sketchpadAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.SortableList,
    {
      element: SortableListAsset,
      settingsSchema: sortableListAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.SupplementalContent,
    {
      element: SupplementalContentAsset,
      settingsSchema: supplementalContentAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.Table,
    { element: TableAsset, settingsSchema: TableAssetSettingsSchema },
  ],
  [
    LcmsAssetType.Text,
    { element: TextAsset, settingsSchema: textAssetSettingsSchema },
  ],
  [
    LcmsAssetType.TextAnswer,
    {
      element: TextAnswerAsset,
      settingsSchema: textAnswerAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.ThreeColumn,
    {
      element: ThreeColumnAsset,
      settingsSchema: threeColumnAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.Timeline,
    { element: TimelineAsset, settingsSchema: timelineAssetSettingsSchema },
  ],
  [
    LcmsAssetType.TwoColumn,
    { element: TwoColumnAsset, settingsSchema: twoColumnAssetSettingsSchema },
  ],
  [
    LcmsAssetType.Video,
    { element: VideoAsset, settingsSchema: videoAssetSettingsSchema },
  ],
  [
    LcmsAssetType.VideoAnswer,
    {
      element: VideoAnswerAsset,
      settingsSchema: videoAnswerAssetSettingsSchema,
    },
  ],
  [
    LcmsAssetType.YouPick,
    { element: YouPickAsset, settingsSchema: youPickAssetSettingsSchema },
  ],
]);

/**
 * Containers that delegate grading to the nested asset the learner picked: the
 * container's own progress row never receives grader feedback, and its points
 * are carried by that nested row instead. Deliberately a list and not a
 * structural test — every question asset can hold nested content in
 * `slots.content` too, so "has slots" would match most of the library.
 */
const gradingContainerTypeSet = new Set<LcmsAssetType>([LcmsAssetType.YouPick]);

export const isGradingContainer = (asset: Pick<AssetDto, "type">): boolean =>
  gradingContainerTypeSet.has(asset.type);

const childAssetSettingSchema = z
  .object({
    reference: z.string().uuid().nullable(),
  })
  .array();

export type NestableAssetDto = AssetDto & {
  slots?: Record<string, NestableAssetDto[]>;
};

/** Confirmation stores a bare number where every other asset stores an object. */
type AssetPointSettings = { point?: { value?: number } | number | null };

/**
 * The points an activity offers, summed over top-level assets only: an asset
 * nested in a grading container carries no point value of its own, because the
 * container holds the points for whichever option the learner picks.
 */
export function sumAssetPoints(nestedAssetDtos: NestableAssetDto[]): number {
  return nestedAssetDtos.reduce((total, asset) => {
    const { point } = asset.settings as AssetPointSettings;

    return total + (typeof point === "number" ? point : point?.value ?? 0);
  }, 0);
}

export function nestAssetDtos(
  assetDtos: AssetDto[],
  rootAssetIds?: string[],
): NestableAssetDto[] {
  const assetDtoMap = new Map(
    assetDtos.map((item) => [item.id, { ...item } as NestableAssetDto]),
  );
  const rootAssetIdSet = new Set(
    rootAssetIds?.filter((id) => assetDtoMap.has(id)) ?? assetDtoMap.keys(),
  );

  for (const item of assetDtoMap.values()) {
    for (const [key, value] of Object.entries(item.settings)) {
      const parsedSetting = childAssetSettingSchema.safeParse(value);

      if (parsedSetting.error) continue;

      const children = parsedSetting.data.flatMap((setting) =>
        setting.reference ? assetDtoMap.get(setting.reference) ?? [] : [],
      );

      item.slots = item.slots ?? {};
      item.slots[key] = children;

      if (rootAssetIds === undefined) {
        children.forEach((child) => rootAssetIdSet.delete(child.id));
      }
    }
  }

  return [...rootAssetIdSet].map((id) => assetDtoMap.get(id)!);
}

export function renderAssetsFromDtos(
  nestedAssetDtos: NestableAssetDto[],
  metadata: AssetComponentMetadata,
  onLearnerResponseChange?: (props: ResponseChangeProps) => void,
  onLearnerSubmit?: (assetId: string) => Promise<GraderFeedbackDto | null>,
  onGradeAsset?: (assetId: string, gradeAsset: GradeAssetDto) => Promise<void>,
  fileHandlers?: FileUploadHandlers,
) {
  return nestedAssetDtos.map(
    function renderNestableAssetFromDto(dto): React.ReactNode {
      const asset = assetMap.get(dto.type);

      if (!asset) return null;

      const progress = dto.progress;
      const parseResult = asset.settingsSchema?.safeParse(
        progress?.feedback?.value || dto.settings,
      );

      const propsParsingError = parseResult?.error;

      if (propsParsingError) {
        console.error(propsParsingError);

        return null;
      }

      if (!parseResult) return null;

      const settings = parseResult.data;

      // FIXME: Workaround for rich text editor output from LCMS which contains
      // non-breaking spaces instead of regular spaces. The same workaround
      // currently exists in LCMS.
      // TODO: Remove once LCMS outputs normalized whitespace.
      for (const prop in settings) {
        if (typeof settings[prop as keyof typeof settings] === "string") {
          // @ts-expect-error No need to type check the temporary workaround.
          settings[prop] = normalizeWhitespace(
            settings[prop as keyof typeof settings],
          );
        }
      }

      const graderFeedback = progress?.feedback
        ? { ...progress?.feedback, value: null }
        : null;

      const renderedSlots =
        dto.slots &&
        mapValues(dto.slots, (slotDtos) =>
          slotDtos.map((slotDto) => renderNestableAssetFromDto(slotDto)),
        );

      const Element = asset.element as React.FC<{
        id: string;
        kind: LcmsAssetType;
        [key: string]: unknown;
      }>;

      return (
        <AssetViewTracker
          id={dto.id}
          isEnabled={
            !dto.progress?.visitedOn &&
            metadata?.mode === "edit" &&
            metadata?.activityStatus === ActivityStatus.InProgress
          }
          key={dto.id}
          onLearnerResponseChange={onLearnerResponseChange}
        >
          <Element
            answer={dto.progress?.response?.value}
            fileHandlers={fileHandlers}
            graderFeedback={graderFeedback}
            id={dto.id}
            kind={dto.type}
            metadata={metadata}
            onGradeAsset={onGradeAsset}
            onLearnerResponseChange={onLearnerResponseChange}
            onLearnerSubmit={onLearnerSubmit}
            slots={renderedSlots}
            {...settings}
          />
        </AssetViewTracker>
      );
    },
  );
}
